import * as React from 'react'
import cx from 'classnames'

interface BannerChildrenProp {
  children: React.ReactNode
}

interface BannerProps extends BannerChildrenProp {
  className?: string
  testId?: string
}

export const Banner = ({ children, className, testId }: BannerProps) => (
  <div
    className={cx(
      'rounded bg-neutral-0 px-2.5 pt-2.5 pb-4 xl:p-2 flex flex-row flex-1 xl:items-center justify-center text-default',
      className
    )}
    data-testid={testId}
  >
    {children}
  </div>
)

// The left icon of a promo banner, designed to be inside of a <Banner /> component
const BannerIcon = ({ children }: BannerChildrenProp) => <>{children}</>

// The wrapper for a banners text content, designed to be inside of a <Banner /> component
const BannerText = ({ children }: BannerChildrenProp) => (
  <div className='flex flex-row flex-wrap flex-1 xl:flex-none ml-2 xl:ml-5'>
    {children}
  </div>
)

// The top bold text of a promo banner, designed to be inside of a <Banner.BannerText /> component
const BannerTitle = ({ children }: BannerChildrenProp) => (
  <div className='font-semibold mb-3 xl:mb-0'>{children}</div>
)

// The secondary text/line of a promo banner, designed to be inside of a <Banner.BannerText /> component
const BannerDescription = ({ children }: BannerChildrenProp) => (
  <div className='w-full xl:w-auto xl:ml-6'>{children}</div>
)

Banner.BannerIcon = BannerIcon
Banner.BannerText = BannerText
Banner.BannerTitle = BannerTitle
Banner.BannerDescription = BannerDescription
